import React from 'react';
import Header from '../component/Header';
import VerTool from '../component/VerTool/VerTool';

const VersionToolPage = () => {
  return (
    <div>
      <Header />
      <VerTool />
    </div>
  );
};

export default VersionToolPage;